import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-team-dialog',
  templateUrl: './team-dialog.component.html',
  styleUrls: ['./team-dialog.component.css']
})
export class TeamDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
